import store from './store'
export default {
  functional: true,

  name: 'BaseInput',

  render (h, context) {
    const { children = [] } = context
    const { message, prefixIcon } = context.props
    const offset = prefixIcon ? [30, 0] : undefined
    const slots = children.map(item => {
      const { slot } = item.data
      if (slot) return <template slot={slot}>{item}</template>
      return item
    })
    const attrs = {
      ...context.data,
      nativeOn: {
        keypress: (event) => {
          if (event.code === 'Enter' || event.code === 'NumpadEnter') {
            store.$emit('search')
          }
        }
      }
    }
    return <form-error message={message} offset={offset} { ...context.data }>
      <el-input { ...attrs } >
        {slots}
      </el-input>
    </form-error>
  }
}
